import { isWeb } from "@tamagui/constants";
import { getConfig, updateConfig } from "./config.js";
import { getThemeCSSRules } from "./helpers/getThemeCSSRules";
import { ensureThemeVariable, proxyThemeToParents } from "./helpers/themes.js";
function addTheme(props) {
  var _a;
  const config = getConfig();
  if (process.env.NODE_ENV === "development") {
    if (!config) {
      throw new Error("No config");
    }
    const theme2 = config.themes[props.name];
    if (!props.update && theme2) {
      return { theme: theme2 };
    }
  }
  const { name: themeName, theme: themeIn, insertCSS } = props;
  const theme = { ...themeIn };
  for (const key in theme) {
    ensureThemeVariable(theme, key);
  }
  const themeProxied = proxyThemeToParents(themeName, theme, config.themes);
  config.themes[themeName] = themeProxied;
  let cssRules = [];
  if (isWeb) {
    if (insertCSS) {
      cssRules = getThemeCSSRules({
        // @ts-ignore this works but should be fixed types
        config,
        themeName,
        names: [themeName],
        theme
      });
      const id = `t_theme_style_${themeName}`;
      const existing = document.querySelector(`#${id}`);
      const style = document.createElement("style");
      style.id = id;
      style.appendChild(document.createTextNode(cssRules.join("\n")));
      document.head.appendChild(style);
      if (existing) {
        (_a = existing.parentElement) == null ? void 0 : _a.removeChild(existing);
      }
    }
  }
  updateConfig("themes", { ...config.themes, [themeName]: themeProxied });
  return {
    theme: themeProxied,
    cssRules
  };
}
export {
  addTheme
};
//# sourceMappingURL=addTheme.js.map
